import { render, staticRenderFns } from "./news18.vue?vue&type=template&id=f8b03cde&"
import script from "./news18.vue?vue&type=script&lang=js&"
export * from "./news18.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports